<!-- 开发者文档 -->
<style scoped>
.developerDocumentation {
    width: 100%;
    background-color: #ffffff;
}
.contentBox {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    text-align: right
}
.leftNav {
    display: inline-block;
    width: 26%;
    padding-left: 7px;
    background-image: -webkit-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: -moz-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: -o-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: linear-gradient(to right, #2b7bff , #04a0f7);
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    vertical-align: top;
    box-shadow: 5px 0 5px #f7f8fa,-5px 0 5px #f7f8fa,0 5px 5px #f7f8fa,0 -5px 5px #f7f8fa;
    -webkit-box-shadow: 5px 0 5px #f7f8fa,-5px 0 5px #f7f8fa,0 5px 5px #f7f8fa,0 -5px 5px #f7f8fa;
    border: 1px solid #e5e8ed;
    text-align: left;
}
.leftNav.fixedTop {
    position: fixed;
    top: 80px;
    left: 50%;
    width: 312px;
    margin-left: -593px;
}
.leftNav ul,
.leftNav ul li {
    width: 100%;
}
.leftNav ul li {
    padding-left: 23px;
    font-size: 18px;
    line-height: 60px;
    background-color: #f5f6f8;
    color: #666666;
    border-bottom: 1px solid #e5e8ed;
    cursor: pointer;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
.leftNav ul li:last-child {
    border-bottom: 0;
}
.leftNav ul li.selection {
    font-size: 22px;
    background-color: #ffffff;
    color: #000000;
}
.leftNav ul li:hover {
    box-shadow: 2px 0 2px #e5e8ed,-2px 0 2px #e5e8ed,0 2px 2px #e5e8ed,0 -2px 2px #e5e8ed;
    -webkit-box-shadow: 2px 0 2px #e5e8ed,-2px 0 2px #e5e8ed,0 2px 2px #e5e8ed,0 -2px 2px #e5e8ed;
}
.leftNav h1 {
    color: #ffffff;
    font-weight: bold;
    font-size: 22px;
    line-height: 60px;
    padding-left: 20px;
}
.fileContent {
    display: inline-block;
    width: 69%;
    margin-left: 4%;
    text-align: left;
    vertical-align: top;
}
.fileContent ul,
.fileContent ul li {
    width: 100%;
}
.fileContent ul li {
    margin-top: 20px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e5e8ed;
}
.fileContent ul:first-child li:first-child {
    margin-top: 0;
}
.fileContent ul li .ask b {
    display: inline-block;
    padding: 10px 15px;
    vertical-align: middle;
    color: #03a1f8;
    font-size: 22px;
    background-color: #bbe8ff;
    font-weight: normal;
}
.fileContent ul li .ask span {
    color: #000000;
    font-size: 18px;
    vertical-align: middle;
    margin-left: 10px;
    font-weight: bold;
}
.fileContent ul li .answer {
    line-height: 24px;
    color: #666666;
    font-size: 14px;
    margin-top: 30px;
    margin-left: 20px;
}
</style>
<template>
    <div class="developerDocumentation">
        <banner></banner>
        <div class="contentBox">
            <div class="leftNav" :class="{'fixedTop': fixedTop}">
                <h1>常见Q&A</h1>
                <ul>
                    <li 
                        v-for="(item,index) in options" 
                        :key="index" 
                        :class="{'selection': index === selectionTypeIndex}" 
                        @click="selectionTypeItem(index)">{{item}}</li>
                </ul>
                
                <!-- <div class="dropDown">
                    <div class="selectionType">
                        {{selectionType}}
                        <i class="dropDownIcon" :class="{'openTypeIcon':showTypeList && playAnimation,'closeTypeIcon': (!showTypeList) && playAnimation}"></i>
                        <input 
                            type="submit" 
                            v-model="selectionType" 
                            @focus="focusDropDown" 
                            @blur="blurDropDown" />
                    </div>
                    <transition name="fade">
                        <div class="typeList" v-show="showTypeList">
                            <div 
                                class="typeItem" 
                                v-for="(item,index) in options" 
                                :key="index" 
                                @click="selectionTypeItem(item,index)">{{item}}</div>
                        </div>
                    </transition>
                </div> -->
            </div>
            <div class="fileContent">
                <ul 
                    v-for="(item,index) in fileList" 
                    :key="index" 
                    :id="'fileContent'+index">
                    <li v-for="(item1,index1) in item.contentList" :key="index1">
                        <p class="ask"><b>问</b><span>{{item1.ask}}</span></p>
                        <p class="answer" v-html="'答：'+item1.answer"></p>
                    </li>
                </ul>
            </div>
        </div>
        <introduce></introduce>
    </div>
</template>
<script>
import banner from '@/components/banner'
import introduce from "@/components/introduce.vue"

export default {
    name: 'developerDocumentation',
    components: {
        banner,
        introduce
    },
    data () {
        return {
            playAnimation: false,
            showTypeList: false,
            selectionType: '5G消息',
            selectionTypeIndex: 0,
            options: ['5G消息','平台类'],
            fileList: [
                {
                    type: '5G消息',
                    contentList: [
                        {
                            ask: '什么是5G消息？',
                            answer: '5G消息是在智能终端原生基础短消息服务的基础上进行了全新升级，能够融合文字、图片、音频、视频、位置等综合信息。'
                        },
                        {
                            ask: '5G消息只有5G手机才能用吗？',
                            answer: '非5G手机，经系统升级后支持5G消息的智能终端均可使用。'
                        },
                        {
                            ask: '目前有哪些手机可以支持5G消息？',
                            answer: 'OPPO、VIVO、小米、三星、中兴等厂商的部分型号手机已支持5G消息。到目前为止，运营商定制终端基本覆盖，安卓厂商自主终端实现部分覆盖。苹果用户可通过“短信小程序”体验5G消息，从而间接实现5G消息的全量手机覆盖。'
                        },
                        {
                            ask: '是否可覆盖其他运营商用户？',
                            answer: '网络系统三家运营商分别建设，目前中国移动网络建设进度较其他两家快。类似传统短信，5G消息三网无法互通。'
                        },
                        {
                            ask: '5G消息怎么计费？',
                            answer: '5G消息是运营商提供的传统短信的升级，届时可参考运营商的具体资费标准。'
                        },
                        {
                            ask: '终端展现形式是否移动统一定制？不同终端展示差别是否会很大？',
                            answer: '不同厂家终端展示所包含的卡片、菜单等功能均为国际标准定义。展示形式、UI设计由各终端厂家自行定义，展示上会有细微差异。'
                        },
                        {
                            ask: '智能终端网络切换后，消息是否会丢？',
                            answer: '终端网络环境发生变化时，系统将尝试对终端进行多次推送，长时间无终端响应，则会进行回落转短方式，届时用户同样可收到短信消息。'
                        },
                        {
                            ask: '应用市场里的中国移动5G消息APP是做什么用的？要用5G消息都需要下载APP吗？',
                            answer: '据了解目前中国移动5G消息APP是用来体验和感受5G消息的，正式商用的5G消息使用的是手机原生的短信消息入口。在手机终端厂商提供可支持5G消息的固件升级之后，即可支持5G消息。'
                        },
                        {
                            ask: '5G消息有什么优势？',
                            answer: '从原短信文字版，升级为支持图片、音频、视频、位置、群聊等新的富媒体信息；基于原生短信窗口，免APP安装，降低企业获客成本；提供按钮、菜单等用户交互入口，增强用户体验；智能chatbot，基于客户输入，预测客户行为，自动匹配富媒体卡片或浮动菜单等。'
                        },
                        {
                            ask: '苹果会不会支持？',
                            answer: '暂不支持，根据5G消息发展情况和运营商的决心，作为手机终端都支持5G消息是一个趋势，苹果手机最终应该会完全支持5G消息。'
                        }
                    ]
                },
                {
                    type: '平台类',
                    contentList: [
                        {
                            ask: '企业目前如何使用平台？可否试用？网址是什么…',
                            answer:'企业用户可通过<a style="color: #04a0f7;" href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">http://5gm.richinfo.cn/dist/index.html#/register</a>，进行开发者账号注册，待账号审核通过，试用期为一个月，届时欢迎咨询试用和洽谈合作。'
                        },
                        {
                            ask: '平台账号是怎么申请的呢？',
                            answer:'平台账号由合作企业发起注册申请，届时将由平台运营人员在后台进行审核，审核通过后开发者可使用平台。'
                        },
                        {
                            ask: '提供接口，还是直接用你们平台?',
                            answer:'平台支持多种方式接入，企业运营可通过平台直接使用5G消息的能力，也可通过OPEN API接口方式接入实现。'
                        },
                        {
                            ask: '如果用户手机不支持5G消息，通过平台发送5G消息给用户后就发送失败了吗？',
                            answer:'在制作消息内容时，可同步配置回落转短内容，当用户手机无法收取5G消息时，将通过短信方式发送给用户。'
                        },
                        {
                            ask: '5G消息按钮或菜单，是否可以做对外链接？',
                            answer:'可以在平台配置按钮时，内嵌链接。'
                        },
                        {
                            ask: '企业客户需具备什么条件才能测试5G消息？',
                            answer:'需要有chatbot账号、5G消息终端和手机白名单。现在属于非商用阶段，各个底层均设置了白名单机制，手机号码需申请加入白名单后，才能搜索到chatbot或者收发5G消息。'
                        },
                        {
                            ask: '与传统短信相比，5G消息在安全性方面是否有差异？',
                            answer:'5G消息安全性优于传统短信，由于引入chatbot概念，运营商需对企业客户进行身份认证，通过运营商认证后，才可发送消息。另外，网络系统各网元间数据传输均为加密传输，移动系统内网络环境均为内网环境，安全性有保。'
                        },
                        {
                            ask: 'Chatbot名称如何申请？是否会被其他人冒用或盗用？',
                            answer:'Chatbot名称需要准备相关资料给运营商进行身份认证审核，包括LOGO、chatbot名称、企业名称等。通过运营商认证并注册审核通过后，方可使用chatbot和发送消息。'
                        },
                        {
                            ask: '5G消息内容如何配置？',
                            answer:'在CSP平台通过可视化界面进行素材和消息内容配置。所见即所得方式，可即时预览、下发预览、在页面上进行模拟交互。'
                        }
                    ]
                }
            ],
            fixedTop: false
        }
    },
    methods: {
        // 定位到某个位置
        scrollBarGo(dom) {
            let nowScrollTop = document.documentElement.scrollTop;
            const domOffsetTop= document.getElementById(dom).offsetTop - 80;
            let timer = setInterval(()=>{
                if (nowScrollTop === domOffsetTop) {
                    clearInterval(timer);
                    return;
                }
                if (nowScrollTop < domOffsetTop) {
                    document.documentElement.scrollTop = document.body.scrollTo = (nowScrollTop+=20);
                    if (nowScrollTop >= domOffsetTop) {
                        document.documentElement.scrollTop = document.body.scrollTo = domOffsetTop;
                        clearInterval(timer);
                    }
                }else if (nowScrollTop > domOffsetTop) {
                    document.documentElement.scrollTop = document.body.scrollTo = (nowScrollTop-=20);
                    if (nowScrollTop <= domOffsetTop) {
                        document.documentElement.scrollTop = document.body.scrollTo = domOffsetTop;
                        clearInterval(timer);
                    }
                }
            },1);
        },
        // 选择
        selectionTypeItem(index) {
            if (this.selectionTypeIndex === index) return;
            // this.selectionTypeIndex = index;
            this.scrollBarGo('fileContent' + index);
        },
        // 根据位置选择
        listenerScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
                domAOffsetTop= document.getElementById('fileContent0').offsetTop - 80,
                domBOffsetTop= document.getElementById('fileContent1').offsetTop - 80,
                fileContentOffsetTop = document.getElementsByClassName('fileContent')[0].offsetTop - 80;
            scrollTop >= fileContentOffsetTop ? this.fixedTop = true : this.fixedTop = false;
            if (scrollTop >= domAOffsetTop && scrollTop < (domBOffsetTop-5)) {
                this.selectionTypeIndex = 0;
            }else if (scrollTop >= (domBOffsetTop-5)) {
                this.selectionTypeIndex = 1;
            }
        }
    },
    mounted() {
        window.addEventListener("scroll",this.listenerScroll,true);
    },
    destroyed() {
        window.removeEventListener("scroll",this.listenerScroll,true);
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/developerDocumentation/index.vue